var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("widget_" + _vm.id), _vm.currentView],attrs:{"type":_vm.current.type}},[_c(_vm.reference,{tag:"component",attrs:{"widget":_vm.current}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }